module.exports = {
    brandInfo: {
        phoneNumber: "18885364210",
        contactEmail: "info@autokarma.ca",
        address: `4675-2785 Commercial Drive Vancouver BC`,
        copyright: `© ${new Date().getFullYear()} Auto Karma`,
        defaultCampaignId: "239",
    },

    images: {
        icon: "images/logo.png",
    },

    project: "auto-karma-credit-application",
    name: "Auto Karma",
    description: `Get the best rates`,

    siteUrl: "https://www.autokarma.ca",
    homeUrl: "/",
    termsUrl: "/terms_of_use",
    privacyPolicyUrl: "/privacy_policy",
    successUrl: "/success",

    hideSuccessCtas: true,
    twilioVerifyMethods: ["sms"],
};